<script setup>
import { computed, onMounted, ref } from "vue";
import { Line } from "vue-chartjs";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  PointElement,
  LineElement,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  PointElement,
  LineElement,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement
);

const props = defineProps({
  data: { type: Array, required: true },
  title: String,
});
const monthNames = [
  "Jan",
  "Fev",
  "Mar",
  "Abr",
  "Mai",
  "Jun",
  "Jul",
  "Ago",
  "Set",
  "Out",
  "Nov",
  "Dez",
];

const labels = computed(() =>
  props.data.map((item) => `${monthNames[item.month - 1]}/${item.year}`)
);
const values = computed(() =>
  props.data.map((item) => parseInt(item.total_consumption))
);

const chartData = computed(() => ({
  labels: labels.value,
  datasets: [
    {
      label: props.title,
      data: values.value,
      borderColor: "#2563eb",
      backgroundColor: "rgba(37, 99, 235, 0.3)",
    },
  ],
}));

const chartOptions = {
  responsive: true,
  plugins: {
    legend: { display: true },
    title: { display: true, text: "Evolução do Consumo" },
  },
};
</script>
<template>
  <Line :data="chartData" />
</template>
 